<template>
  <div>
    <i class="fa fa-search mr-2 text-muted" aria-hidden="true"
							data-test="SearchListIcon" id="SearchListIcon"></i>
    {{ item.search_name }}
    <span style="color: dodgerblue; font-weight: 600;"
          v-if="item && item.parent_name"
										data-test="SearchListParentName"
										id="SearchListParentName"
    >
      <span data-test="SearchListIn" id="SearchListIn">in</span>
      {{ item.parent_name }}
    </span>
  </div>
</template>

<script>
export default {
	props: {
		item: { required: true },
		searchText: { required: true },
		items: {}
	}
}
</script>
